/**
 * Looks up an org in a list by uid. Returns null when the uid is missing or
 * does not match any entry. Generic over any object that has a `uid: string`
 * so it works for both `OrgSwitcherItem` and `EffectiveOrg`.
 */
export function findOrgByUid<T extends { uid: string }>(
    orgs: readonly T[] | null | undefined,
    uid: string | null | undefined,
): T | null {
    if (!uid || !orgs?.length) return null;
    return orgs.find(o => o.uid === uid) ?? null;
}
